import { useMemo } from 'react';
import { getScheduledMaintenanceStatus } from '../../utils/maintenanceUtils';

export const useMaintenanceMode = () => {
  const maintenanceStatus = useMemo(() => {
    return getScheduledMaintenanceStatus();
  }, []);

  return {
    isInMaintenance: maintenanceStatus.isActive,
    isScheduledMaintenance: maintenanceStatus.isScheduled,
    maintenanceWindow: {
      start: maintenanceStatus.startTime,
      end: maintenanceStatus.endTime,
    },
  };
};
